import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  CreateFeature, EffectiveUserPermissions, Feature,
  RolePermission, RolePermissionGroup, UpdateFeature,
  UserPermission, UserPermissionGroup
} from '../models/permission.model';
import { PagedResult } from '../models/external-sync.model';

@Injectable({ providedIn: 'root' })
export class FeatureService {
  private http = inject(HttpClient);
  private url = `${environment.rpsApiUrl}/api/features`;

  getAll() { return this.http.get<Feature[]>(this.url); }
  getPaged(page: number, pageSize: number, search?: string) {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (search) params = params.set('search', search);
    return this.http.get<PagedResult<Feature>>(`${this.url}/paged`, { params });
  }
  getById(id: string) { return this.http.get<Feature>(`${this.url}/${id}`); }
  create(dto: CreateFeature) { return this.http.post<Feature>(this.url, dto); }
  update(id: string, dto: UpdateFeature) { return this.http.put<Feature>(`${this.url}/${id}`, dto); }
  delete(id: string) { return this.http.delete(`${this.url}/${id}`); }

  getRolePermissions(roleId: string) {
    return this.http.get<RolePermissionGroup[]>(`${this.url}/roles/${roleId}`);
  }
  updateRolePermission(roleId: string, permissionId: string, isAllowed: boolean) {
    return this.http.put<RolePermission>(`${this.url}/roles/${roleId}/permissions/${permissionId}`, { isAllowed });
  }

  getUserPermissions(userId: string) {
    return this.http.get<UserPermissionGroup[]>(`${this.url}/users/${userId}`);
  }
  updateUserPermission(userId: string, permissionId: string, isAllowed: boolean) {
    return this.http.put<UserPermission>(`${this.url}/users/${userId}/permissions/${permissionId}`, { isAllowed });
  }
  resetUserPermission(userId: string, permissionId: string) {
    return this.http.delete(`${this.url}/users/${userId}/permissions/${permissionId}`);
  }

  bulkUpdateRolePermissions(roleId: string, dto: { permissions: { permissionId: string; isAllowed: boolean }[] }) {
    return this.http.put(`${this.url}/roles/${roleId}/permissions/bulk`, dto);
  }

  bulkUpdateUserPermissions(userId: string, dto: { permissions: { permissionId: string; isAllowed: boolean }[] }) {
    return this.http.put(`${this.url}/users/${userId}/permissions/bulk`, dto);
  }

  getEffectivePermissions(userId: string) {
    return this.http.get<EffectiveUserPermissions>(`${this.url}/users/${userId}/effective-permissions`);
  }
}
